import * as jsxRuntime from "/home/jenkins/workspace/ucts_Guidance_PG_pg-frontend_dev/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment